import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
    'Access-Control-Allow-Credentials': 'true',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UmsService {
  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router,
    private location: Location,
    private spinner: NgxSpinnerService,

  ) {
    this.APIService = environment.serviceUrl;
    // this.secretdata = this.secretdata;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });

  }
  private tclcData: any;

  setTclcData(data: any) {
    this.tclcData = data;
  }

  getTclcData() {
    return this.tclcData;
  }
  private history: string[] = [];
  public secretdata = [];
  public secretA = [];
  public secretB = [];
  public courseData = [];
  public examData = [];
  public examstrData = [];
  public disable2: Boolean = true;
  public disable4: Boolean = true;
  public disable5: Boolean = true;
  public disable6: Boolean = true;
  public disable7: Boolean = true;
  public profileIcon2: any;
  sortColumn
  sortDirection
  private APIService: string = environment.serviceUrl; // this has to be load from an external config file

  Exam;
  Semester;
  private sharedData: string;
  //sort working only up n down not apl
  // sortData(data: any[], column: string): any[] {
  //   return data.sort((a, b) => (a[column] > b[column] ? 1 : -1));
  // }

  sortData(data: any[], column: string, ascending: boolean = true): any[] {
    return data.sort((a, b) => {
      if (!a) {
        return 0; // Handle cases where the data is undefined
      }

      if (!b) {
        return 0; // Handle cases where the data is undefined
      }

      if (!a.hasOwnProperty(column)) {
        return 0; // Handle cases where column doesn't exist in object A
      }

      if (!b.hasOwnProperty(column)) {
        return 0; // Handle cases where column doesn't exist in object B
      }

      const valueA = a[column];
      const valueB = b[column];

      if (valueA === undefined || valueB === undefined) {
        return 0; // Handle cases where valueA or valueB is undefined
      }

      // Convert values to strings for consistent comparison
      const stringA = String(valueA);
      const stringB = String(valueB);

      // Use localeCompare for alphanumeric sorting
      const comparison = stringA.localeCompare(stringB, undefined, { numeric: true });

      return ascending ? comparison : -comparison;
    });
  }

  setData(data: string) {
    this.sharedData = data;
  }

  getData(): string {
    return this.sharedData;
  }
  deleteuserroleData(id: any) {
    throw new Error('Method not implemented.');
  }
  getNoimg(e) {
    this.profileIcon2 = e
  }
  openSnackbar(message: string) {
    return this.snackBar.open(message, 'close', {
      verticalPosition: 'top',
      horizontalPosition: 'center',
      duration: 2000,
      panelClass: ['snackbarStyle'],
    });
  }
  private log(message: string) {
  }
  public secret(e) {
    // environment.key = e;
    this.secretdata = e;
    sessionStorage.setItem('ShortName', this.secretdata['InstituteShortName']);
  }
  public secret2(e) {
    this.secretA = e;
  }
  getsecreat(payload): Observable<any> {
    return this.http.post(this.APIService + '/login/projParam/fetch', payload).pipe();
  }

  ForgetPswd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/forget-password', payload).pipe();
  }

  changePswd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/change-password', payload).pipe();
  }

  getStudentMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/students').pipe();
  }

  getTeachersMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/teachers').pipe();
  }

  getParentsMenu(): Observable<any> {
    return this.http.get(this.APIService + '/menu/parents').pipe();
  }

  login(payload): Observable<any> {
    return this.http.post(this.APIService + '/login/Adminlogin', payload).pipe();
  }

  SearchCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/SearchCollege/fetch', payload).pipe();
  }

  getCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country/fetch', payload).pipe();
  }

  addCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country', payload).pipe();
  }

  updateCountry(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/country', payload).pipe();
  }

  searchCountry(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/country/fetch', payload).pipe();
  }

  deleteCountry(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/country', payload).pipe();
  }

  getState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/state/fetch', payload).pipe();
  }

  addState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/state', payload).pipe();
  }

  updateState(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/state', payload).pipe();
  }

  searchState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/state/fetch', payload).pipe();
  }

  deleteState(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/state', payload).pipe();
  }

  getDivision(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/division/fetch', payload).pipe();
  }

  addDivision(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/division', payload).pipe();
  }

  updateDivision(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/division', payload).pipe();
  }

  searchDivision(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/division/fetch', payload).pipe();
  }

  deleteDivision(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/division', payload).pipe();
  }

  getTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town/fetch', payload).pipe();
  }

  addTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town', payload).pipe();
  }

  updateTown(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/town', payload).pipe();
  }

  searchTown(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/town/fetch', payload).pipe();
  }

  deleteTownnn(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/town', payload).pipe();
  }

  getCollegeType(): Observable<any> {
    return this.http.get(this.APIService + '/masters/college-type').pipe();
  }

  addUserForPermission(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/CreateUser', payload).pipe();
  }

  updateUserForPermission(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/UpdateLoginMaster', payload).pipe();
  }

  addPermission(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/Permission', payload).pipe();
  }

  updatePermission(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/Permission', payload).pipe();
  }

  getPermission(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/Permission/fetch', payload).pipe();
  }
  upsertMultiplePermissions(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/security/Permission/upsertMultiple', payload).pipe();
  }

  getIAMarksReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/AllIaMarksReport/fetch', payload).pipe();
  }

  addFaculty(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/faculty', payload).pipe();
  }

  updateFaculty(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/faculty', payload).pipe();
  }

  getFaculty(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/faculty/fetch', payload).pipe();
  }
  getEligibilityCriteria(payload: number): Observable<any> {
    return this.http.get(this.APIService + '/masters/get-eligibility-criteria?emId=' + payload).pipe();
  }

  saveCriteria(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/masters/save-eligibility-criteria', payload).pipe();
  }
  searchFaculty(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/faculty/fetch', payload).pipe();
  }

  getCollegeCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/college-course/fetch', payload).pipe();
  }

  getUserCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToCourse/fetch', payload).pipe();
  }

  getUserExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToExam/fetch', payload).pipe();
  }

  AddUserExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToExam', payload).pipe();
  }

  AddUserCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToCourse', payload).pipe();
  }

  getCoursePattern(): Observable<any> {
    return this.http.get(this.APIService + '/masters/course-pattern').pipe();
  }

  getCourseMedium(): Observable<any> {
    return this.http.get(this.APIService + '/masters/medium').pipe();
  }

  getScaleDown(): Observable<any> {
    return this.http.get(this.APIService + '/masters/course-scale-down').pipe();
  }

  getEvaluation(): Observable<any> {
    return this.http.get(this.APIService + '/masters/evaluation-type').pipe();
  }

  getRules(): Observable<any> {
    return this.http.get(this.APIService + '/masters/course-rules').pipe();
  }

  getGradePoints(): Observable<any> {
    return this.http.get(this.APIService + '/masters/grade-point').pipe();
  }

  getGpaMarks(): Observable<any> {
    return this.http.get(this.APIService + '/masters/gpa-mark').pipe();
  }

  getIntegratedCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course/fetch', payload).pipe();
  }

  addInteCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course', payload).pipe();
  }

  addCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code', payload).pipe();
  }

  updateCode(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/code', payload).pipe();
  }

  getCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code/fetch', payload).pipe();
  }

  searchCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code/fetch', payload).pipe();
  }

  addCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types', payload).pipe();
  }

  updateCodeType(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/code-types', payload).pipe();
  }

  getCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  searchCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  getSubTotal(): Observable<any> {
    return this.http.get(this.APIService + '/masters/special-class-rule').pipe();
  }

  addSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session', payload).pipe();
  }

  updateSession(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/session', payload).pipe();
  }

  getSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/fetch', payload).pipe();
  }

  searchSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/fetch', payload).pipe();
  }

  closeSession(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/close', payload).pipe();
  }

  ExmSchDD(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examForSh/fetch', payload).pipe();
  }

  addExmSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamSchedule', payload).pipe();
  }

  updateExmSch(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ExamSchedule', payload).pipe();
  }

  getCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseForSchedule/fetch', payload).pipe();
  }

  getCourseSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule/fetch', payload).pipe();
  }

  NewCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get_NewCousreSchedule', payload).pipe();
  }

  fetchSubs(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ExamSubRg/fetch', payload).pipe();
  }

  NewSearchCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get_NewSearchCoEditSchedule', payload).pipe();
  }

  addCoSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule', payload).pipe();
  }

  updateCoSch(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/CourseSchedule', payload).pipe();
  }

  getExmSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  searchExmSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  addExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam', payload).pipe();
  }

  updateExam(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam', payload).pipe();
  }

  getExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
  }

  searchExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
  }

  deleteExam(payload): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        payload,
      },
    };
    return this.http.post(this.APIService + '/masters/exam', options).pipe();
  }

  updateMappingSubject(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/updateSubMap', payload).pipe();
  }

  addExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  updateExamSub(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  getExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject/fetch', payload).pipe();
  }

  searchExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject/fetch', payload).pipe();
  }

  addExamDiv(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-division', payload).pipe();
  }

  getExamDiv(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-division/fetch', payload).pipe();
  }

  searchExamDiv(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-division/fetch', payload).pipe();
  }

  addExamAggr(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-aggr', payload).pipe();
  }

  getExamAggr(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-aggr/fetch', payload).pipe();
  }

  searchExamAggr(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-aggr/fetch', payload).pipe();
  }

  addExamSem(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/semester', payload).pipe();
  }

  updateExamSem(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/semester', payload).pipe();
  }

  getExamSem(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/semester/fetch', payload).pipe();
  }

  addExamHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-head', payload).pipe();
  }

  getMarkList(payload): Observable<any> {
    return this.http.get(this.APIService + '/masters/mark-list-format').pipe();
  }

  getExamHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-head/fetch', payload).pipe();
  }

  addParameter(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/parameters', payload).pipe();
  }

  getParameter(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/parameters/fetch', payload).pipe();
  }

  addSessionClosed(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/session/close', payload).pipe();
  }

  addIntCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course', payload).pipe();
  }

  getIntCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/integrated-course/fetch', payload).pipe();
  }

  addUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/user', payload).pipe();
  }

  updateUser(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/user', payload).pipe();
  }

  getUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/user/fetch', payload).pipe();
  }

  searchUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/user/fetch', payload).pipe();
  }

  addCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/course', payload).pipe();
  }

  getCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/course/fetch', payload).pipe();
  }

  updateCourse(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/course', payload).pipe();
  }

  getExamStream(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-stream/branch/fetch', payload).pipe();
  }

  addCourseCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/college-course', payload).pipe();
  }

  getFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetemp', payload).pipe();
  }

  payOfflineFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/Offlinepayment', payload).pipe();
  }

  getDataForGridSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/get-subject-mapping', payload).pipe();
  }

  getMapSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/get-for-subject-mapping', payload).pipe();
  }

  submitExamStream(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-stream/branch', payload).pipe();
  }

  updateExamStream(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam-stream/branch', payload).pipe();
  }

  getUserData(id): Observable<any> {
    return this.http.get(this.APIService + '/security/get-login-master/' + id + '/10/1/1').pipe();
  }

  getUsers(PageSize, PageNumber): Observable<any> {
    return this.http.get(this.APIService + '/security/get-login-master/0' + '/' + PageSize + '/' + PageNumber + '/1').pipe();
  }

  getOneUsers(payload): Observable<any> {
    return this.http.get(this.APIService + '/security/get-login-master/' + payload + '/10/1/1').pipe();
  }

  getExamTT(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SearchExamTime/fetch', payload).pipe();
  }

  getExamHoliday(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetHolidayDate/fetch', payload).pipe();
  }

  getSearchHoliday(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetHolidayDate/fetch', payload).pipe();
  }

  SubmitHoliday(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InsertHolidayDate', payload).pipe();
  }

  getExamSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamSchedule/fetch', payload).pipe();
  }

  submitExamTT(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamTime', payload).pipe();
  }

  getInputSearch(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchInSpFlag/fetch', payload).pipe();
  }

  getExmFrmDrpList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExamFormDrpList/fetch', payload).pipe();
  }

  ICRMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ICRmarksGenerate', payload).pipe();
  }

  generateExamMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GenEditMarks', payload).pipe();
  }

  SaveExmFrm(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditFormSub', payload).pipe();
  }

  ExmFormSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditFormSub/fetch', payload).pipe();
  }

  EditMarks(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditMarks', payload).pipe();
  }

  validateGeneratedExamMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/VldtEditMarks', payload).pipe();
  }

  fetchGeneratedExamMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditMarks/fetch', payload).pipe();
  }

  ControlLock(payload): Observable<any> {
    return this.http.put(this.APIService + '/lock/EditControlLock', payload).pipe();
  }

  ValidateMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/VldtEditMarks', payload).pipe();
  }

  ChangeMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ChngEditList', payload).pipe();
  }

  getRegnFrmList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnFormEditListCo/fetch', payload).pipe();
  }

  getCentForAll(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchCentForAlloc/fetch', payload).pipe();
  }

  updateCentAll(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/CentreAllo', payload).pipe();
  }

  getNewEmCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/general/NewEmCodes/fetch', payload).pipe();
  }

  updateNewEmCode(payload): Observable<any> {
    return this.http.put(this.APIService + '/general/NewEmCodes', payload).pipe();
  }

  getSessionColgCo(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgMap/fetch', payload).pipe();
  }

  addSessionColgCo(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgMap', payload).pipe();
  }

  updateSessionColgCo(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/SessionCoColgMap', payload).pipe();
  }

  searchSessCoColg(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgMaplist/fetch', payload).pipe();
  }

  CheckValidDate(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CheckValidDate/fetch', payload).pipe();
  }

  addSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgCutOff', payload).pipe();
  }

  updateSessionCutOff(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/SessionCoColgCutOff', payload).pipe();
  }

  FeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/FeeDetailsReports/fetch', payload).pipe();
  }

  Feebypass(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/getFeebypass/fetch', payload).pipe();
  }

  searchChoiceSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub/fetch', payload).pipe();
  }

  getChoicesubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceForSub/fetch', payload).pipe();
  }

  getTableDataForChoiceSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub/fetch', payload).pipe();
  }

  addChoiceSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub', payload).pipe();
  }

  createChoiceSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/ExamChoiceSub', payload).pipe();
  }

  updateChoiceSubject(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/ExamChoiceSub', payload).pipe();
  }

  getSecretData(): Observable<any> {
    return this.http.get(this.APIService + '/security/SecreatData').pipe();
  }

  listSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgCutOfflist/fetch', payload).pipe();
  }

  findSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoColgCutOff/fetch', payload).pipe();
  }

  getStdSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/stuFormSettings/StuFormDetails/fetch', payload).pipe();
  }

  updateStdSetting(payload): Observable<any> {
    return this.http.put(this.APIService + '/stuFormSettings/StuFormDetails', payload).pipe();
  }

  getExamSubMapFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject-mapping/fetch', payload).pipe();
  }

  getSubjectList(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetsingleRecordEsSubMapG/fetch', payload).pipe();
  }

  getStuAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSet/fetch', payload).pipe();
  }

  getStuIASub(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceIAHead/fetch', payload).pipe();
  }


  getThHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/SearchSubHead/fetch', payload).pipe();
  }

  getStuIASubHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceListIAHead/fetch', payload).pipe();
  }

  saveStuIAAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceIAHead', payload).pipe();
  }

  updateStuIAAtd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceIAHead', payload).pipe();
  }

  saveStuIAAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSettingsIAHead', payload).pipe();
  }

  checkDate(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CheckAdmissionDate/fetch', payload).pipe();
  }

  NewSemStuAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/AttendanceDetailsNewSem/fetch', payload).pipe();
  }

  updateStuIAAtdSet(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceSettingsIAHead', payload).pipe();
  }

  getStuIAAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSetIAHead/fetch', payload).pipe();
  }

  getStuIAAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceListIAHead/fetch', payload).pipe();
  }

  saveStuAtdSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceSet', payload).pipe();
  }

  updateStuAtdSet(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceSet', payload).pipe();
  }

  getExamSubjectListFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMapS/fetch', payload).pipe();
  }

  getExamGroupListFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMapG/fetch', payload).pipe();
  }

  getGetCode(): Observable<any> {
    return this.http.get(this.APIService + '/masters/coty').pipe();
  }

  getSubFlag(): Observable<any> {
    return this.http.get(this.APIService + '/masters/subTotFlag').pipe();
  }

  getCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage/fetch', payload).pipe();
  }

  getCollegeFaculty(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage-faculty/fetch', payload).pipe();
  }

  getCourses(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/SessionCoFacultyMap/fetch', payload).pipe();
  }

  getCoursesWithLevel(payload: any): Observable<any> {
    const spPayload = {
        FcCode: payload.FcCode
    };
    return this.http.post(this.APIService + '/masters/courses-with-level/fetch', spPayload).pipe();
  }

  getCentresFromAllocation(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/students/centres/allocation/fetch', payload).pipe();
}

  searchCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage/fetch', payload).pipe();
  }

  addCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/collage', payload).pipe();
  }

  updateCollege(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/collage', payload).pipe();
  }

  getDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district/fetch', payload).pipe();
  }

  addDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district', payload).pipe();
  }

  updateDistrict(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/district', payload).pipe();
  }

  searchDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/district/fetch', payload).pipe();
  }

  deleteDistrict(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/district', payload).pipe();
  }

  getOption(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/EsOptions/fetch', payload).pipe();
  }

  getDefineGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/SearchEsGrades/fetch', payload).pipe();
  }

  addDefineGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GradesPts', payload).pipe();
  }

  updateDefineGrid(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/UpdateEsGrades', payload).pipe();
  }

  getThPr(): Observable<any> {
    return this.http.get(this.APIService + '/masters/ThPr/fetch').pipe();
  }

  getValType(): Observable<any> {
    return this.http.get(this.APIService + '/masters/ValType').pipe();
  }

  getCredit(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CredFrExm/fetch', payload).pipe();
  }

  addExamSubSetup(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  updateExamSubSetup(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/exam-subject', payload).pipe();
  }

  getClass(): Observable<any> {
    return this.http.get(this.APIService + '/masters/special-class-rule').pipe();
  }

  getDistrictWiseTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/DistrictWiseTehsil/fetch', payload).pipe();
  }

  getUserList(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userList/fetch', payload).pipe();
  }

  getStateWiseDistrict(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/StateWiseDistrict/fetch', payload).pipe();
  }

  getUserRole(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/searchUserRoleWise', payload).pipe();
  }

  addUserCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/userToCourse', payload).pipe();
  }

  getSingleRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMap/fetch', payload).pipe();
  }

  getParentRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/singleRecordEsSubMapParent/fetch', payload).pipe();
  }

  getSupExamRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  getSupExamInputs(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ExamShInputs/fetch', payload).pipe();
  }

  submitSupExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examControl', payload).pipe();
  }

  ValidateSCHExamInput(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/VldtSchInput/fetch', payload).pipe();
  }

  getSupCourseRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule/fetch', payload).pipe();
  }

  getSupCourseInputs(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseShInputs/fetch', payload).pipe();
  }

  submitSupCourse(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/courseEditControl', payload).pipe();
  }

  getResultGridList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/resultProcessing', payload).pipe();
  }

  getResultBranchDistrictList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SchStr/fetch', payload).pipe();
  }

  getSupExamEditRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examEditControl/fetch', payload).pipe();
  }

  getSupCourseEditRecord(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/courseEditControl/fetch', payload).pipe();
  }

  submitCode_R_(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcResNew', payload).pipe();
  }

  submitCode_U_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ProcUpdtRes', payload).pipe();
  }

  submitCode_C_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignControlSheet', payload).pipe();
  }

  submitCode_D_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignCodes', payload).pipe();
  }

  submitCode_RP_(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcResNew', payload).pipe();
  }

  submitCode_F_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignMarksFoil', payload).pipe();
  }

  submitCode_O_(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignRollNos', payload).pipe();
  }

  scheduleLockInit(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateScheduleLock', payload).pipe();
  }

  ValidateRecordsS(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/VldtProcResult', payload).pipe();
  }

  VldtRecordU(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ProcUpdtRes', payload).pipe();
  }

  VldtRecordRP(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcResNew', payload).pipe();
  }

  submitRegistrationNumberProcess(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProcRgNo/fetch', payload).pipe();
  }

  getcourseRegistrationList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CoSchFrRgNo/fetch', payload).pipe();
  }

  getCodeList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GenCent/fetch', payload).pipe();
  }

  UpdateCodeDistrict(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateSpFlag', payload).pipe();
  }

  createGenCent(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GenCent', payload).pipe();
  }

  updateGenCent(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/GenCent', payload).pipe();
  }

  fetchExamForQP(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SearchSchedule/fetch', payload).pipe();
  }

  addQPCode(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/questionPaper', payload).pipe();
  }

  SearchSTR(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SchStr/fetch', payload).pipe();
  }

  updateQPCode(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/questionPaper', payload).pipe();
  }

  fetchQPDataForGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/questionPaper/fetch', payload).pipe();
  }

  ValidateSCHInput(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/VldtSchInput/fetch', payload).pipe();
  }

  UpdateSCHInput(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateSchInput', payload).pipe();
  }

  UpdateSCHExamInput(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdateSchInput', payload).pipe();
  }

  UpdateSCHExamCenterAllocationInput(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdCentreAlloExam', payload).pipe();
  }

  fetchCategory(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CasteList/fetch', payload).pipe();
  }

  fetchRegiList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnFormEditListCo/fetch', payload).pipe();
  }

  fetchRegiListForGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnForm/fetch', payload).pipe();
  }

  listofSubjects(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ExamSubRg/fetch', payload).pipe();
  }

  addRegiForm(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/RegnForm', payload).pipe();
  }

  addRegiFormScrutiny(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/NewRegnForms', payload).pipe();
  }

  ScrutinyLock(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CheckScrutinyLock', payload).pipe();
  }

  updateRegiForm(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/RegnForm', payload).pipe();
  }

  validateRegiForm(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditRegnForms', payload).pipe();
  }

  SearchFeeAdm(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetemp_Adm/fetch', payload).pipe();
  }

  generateExams(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/genProcNewEf', payload).pipe();
  }

  PutvalidateGeneratedExams(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditExamForms', payload).pipe();
  }

  fetchExamRegList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExamFormDrpList/fetch', payload).pipe();
  }

  fetchInputExams(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExamForm/fetch', payload).pipe();
  }

  fetchInputExamsValid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditExamForm/fetch', payload).pipe();
  }

  fetchEditMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/getEditMarks/fetch', payload).pipe();
  }

  fetchMarksEntryListForGrid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditMarks/fetch', payload).pipe();
  }

  addMarksEntry(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditMarks', payload).pipe();
  }

  getCentAll(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchCentreAllo/fetch', payload).pipe();
  }

  addZone(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/zone', payload).pipe();
  }

  fetchZone(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/zone/fetch', payload).pipe();
  }

  updateZone(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/zone', payload).pipe();
  }

  fetchExShedule(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/examSchedule/fetch', payload).pipe();
  }

  checkICR(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchInICR', payload).pipe();
  }

  checkForDecimal(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchExmMarksD', payload).pipe();
  }

  SearchResult(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditChResult/fetch', payload).pipe();
  }

  searchExmList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ExamForm/fetch', payload).pipe();
  }

  SearchUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/search_login_master', payload).pipe();
  }

  addResult(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditChResult', payload).pipe();
  }

  updateResult(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditChResult', payload).pipe();
  }

  courseClg(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/stucourseClgMap/fetch', payload).pipe();
  }

  getAssLvl(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AssignRole/fetch', payload).pipe();
  }

  addAssLvl(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AssignRole', payload).pipe();
  }

  ICRTxt(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/ICRMarksTxt', payload).pipe();
  }

  SearchEsGrades(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/SearchEsGrades/fetch', payload).pipe();
  }

  getStdAtdList(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/listfrAttnd', payload).pipe();
  }

  getStdAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendance/fetch', payload).pipe();
  }

  saveStdAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendance', payload).pipe();
  }

  updateStdAtd(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendance', payload).pipe();
  }

  getScrutiny(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchScrutiny/fetch', payload).pipe();
  }

  getAppStu(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchScrutinyFrAttendance/fetch', payload).pipe();
  }

  updateScrutiny(payload): Observable<any> {
    return this.http.put(this.APIService + '/admin/Scrutiny', payload).pipe();
  }

  SearchRegnSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnSub/fetch', payload).pipe();
  }

  SearchExamSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/FormSub/fetch', payload).pipe();
  }

  SearchRegnExam(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnExam/fetch', payload).pipe();
  }

  SearchRegn(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnForm/fetch', payload).pipe();
  }

  reportDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportDetails/fetch', payload).pipe();
  }

  SrchCoUpdt(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchCoursesUpdated/fetch', payload).pipe();
  }

  reportData(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportsData', payload).pipe();
  }

  ReportExm(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchSchForRpt/fetch', payload).pipe();
  }

  GetUserWise(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetUserWiseCoColg', payload).pipe();
  }

  reportDetailFt(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportDetails/fetch', payload).pipe();
  }

  reportHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportHeaders/fetch', payload).pipe();
  }

  addRpFt(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/reportHeaders', payload).pipe();
  }

  fetchHOM(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/HOM/fetch', payload).pipe();
  }

  fetchIntakeFilter(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchIntakeFilter', payload).pipe();
  }

  getScrutinyCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CountScrutiny', payload).pipe();
  }

  fetchPersonalDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/personalDetails/fetch', payload).pipe();
  }

  fetchContactDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/AddressDetails/fetch', payload).pipe();
  }

  fetchReservationDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/Reservation/fetch', payload).pipe();
  }

  fetchQualificationDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/Qualification/fetch', payload).pipe();
  }

  fetchAdditionalDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/AdditionalDetails/fetch', payload).pipe();
  }

  fetchMinority(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/MinorityType/fetch', payload).pipe();
  }

  fetchPhotoSignDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StudentPhotoAndSign/fetch', payload).pipe();
  }

  fetchAddmissionDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/AdmissionDetails/fetch', payload).pipe();
  }

  fetchDocumentDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StuDocumentUpload/fetch', payload).pipe();
  }

  fetchScrutinyHistory(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/ScrutinyHistory', payload).pipe();
  }

  ScrutinyHistoryTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/ScrutinyHistoryTable/fetch', payload).pipe();
  }

  addFeeHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feehead', payload).pipe();
  }

  updateFeeHead(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/feehead', payload).pipe();
  }

  getFeeHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feehead/fetch', payload).pipe();
  }

  fetchCodeType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/code-types/fetch', payload).pipe();
  }

  addFeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feetemplate', payload).pipe();
  }

  addFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  FeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FeeTemplateDetails', payload).pipe();
  }

  RgId(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/getRgDetails/fetch', payload).pipe();
  }

  GetEcId(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetEcIdStud/fetch', payload).pipe();
  }

  fetchLatestEcid(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetNextExam/fetch', payload).pipe();
  }

  getFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FeesByPass/fetch', payload).pipe();
  }

  addFeeTemplet1(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  fetchCheckFeeMode(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/CheckFeeMode/fetch', payload).pipe();
  }

  saveApplicationDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ApplicationTrackDate', payload).pipe();
  }

  getSearchFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeeDetails', payload).pipe();
  }

  updateFeeTemplet(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/feetemplate', payload).pipe();
  }

  getFeeTemplet(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feetemplate/fetch', payload).pipe();
  }

  searchFeeTemplate(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feetemplate/fetch', payload).pipe();
  }

  searchFeeHead(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feehead/fetch', payload).pipe();
  }

  updateFeeTemplet1(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/PayFeeDetails', payload).pipe();
  }

  addFeeTempletMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/templatemapping', payload).pipe();
  }

  updateFeeTempletMapping(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/templatemapping', payload).pipe();
  }

  CheckRollNo(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CheckRollNo/fetch', payload).pipe();
  }

  CheckExamTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CheckExamTimeTable/fetch', payload).pipe();
  }

  getFeeTempletMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/templatemapping/fetch', payload).pipe();
  }

  getDownloadDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StudentDownloadDocument/fetch', payload).pipe();
  }

  addFeeSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feeset', payload).pipe();
  }

  updateFeeSetting(payload): Observable<any> {
    return this.http.put(this.APIService + '/fees/feeset', payload).pipe();
  }

  getFeeSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feeset/fetch', payload).pipe();
  }

  getCollegeBySession(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/SearchIntakeCollege', payload).pipe();
  }

  centPaper(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/centPaperExtr', payload).pipe();
  }

  MarkLRem(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/AMDMarkLRem', payload).pipe();
  }

  AdmitRem(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/AMDAdmitRem', payload).pipe();
  }

  SetReportParam(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SetReportParam', payload).pipe();
  }

  renderReport(payload): Observable<any> {
    return this.http.post('http://203.112.134.250/api/Reports/UMS/RenderReportV2', payload, { responseType: 'blob' })
    // return this.http.post('http://umsreportsapidevedition.universus.co.in/api/Reports/UMS/RenderReportV2', payload, { responseType: 'blob' })
  }

  renderHbsReport(payload): Observable<any> {
    // return this.http.post('http://14.139.121.188/umsreportsapi/api/Reports/UMS/RenderReportV2',payload,{responseType: 'blob'})
    return this.http.post(this.APIService + '/reports/hbsreports', payload, { responseType: 'blob' })
  }

  fetchstucourseClgMap(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/stucourseClgMap/fetch', payload).pipe();
  }

  searchFeeTempMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/templatemapping/fetch', payload).pipe();
  }

  searchFeeTempSetting(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/feeset/fetch', payload).pipe();
  }

  addStdAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CtStuAtndMaster', payload).pipe();
  }

  updateStdAttendance(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/CtStuAtndMaster', payload).pipe();
  }

  AdmFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/FeePaidDetails/fetch', payload).pipe();
  }

  ExmFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetExamFeePaidDetails/fetch', payload).pipe();
  }

  StuAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendance/fetch', payload).pipe();
  }

  StuAttendanceNewSem(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttendanceNewSem/fetch', payload).pipe();
  }

  getIAAtd(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StuAttndDetailsIAHead/fetch', payload).pipe();
  }

  EnterStdAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CtStuAtndEntry', payload).pipe();
  }


  updateTable(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/CtStuAtndEntry', payload).pipe();
  }

  getSearchTranscriptFeeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchTranscriptFeeDetails', payload).pipe();
  }

  searchStudentAttendance(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CtStuAtndEntry/fetch', payload).pipe();
  }

  getReportsMenu(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/getRptObj', payload).pipe();
  }

  getExamCollegeForReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Search_ExamCollege', payload).pipe();
  }

  unpaidFeeReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/unpaidFeeReport/fetch', payload).pipe();
  }

  DashBoardCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/dashboardCounts/fetch', payload).pipe();
  }

  CourseColgCounts(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/CourseColgCounts/fetch', payload).pipe();
  }

  StuPerform(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/StudentPerformanceGraph/fetch', payload).pipe();
  }

  GenderCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/DashboardGenderCounts/fetch', payload).pipe();
  }

  CasteCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/DashboardCasteCounts/fetch', payload).pipe();
  }

  AdmissionCount(payload): Observable<any> {
    return this.http.post(this.APIService + '/dashboard/DashboardCollegeWiseAdmission/fetch', payload).pipe();
  }

  getTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Tehsil/fetch', payload).pipe();
  }

  searchTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Tehsil/fetch', payload).pipe();
  }

  addTehasil(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Tehsil', payload).pipe();
  }

  updateTehasil(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/Tehsil', payload).pipe();
  }

  searchCouSch(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/CourseSchedule/fetch', payload).pipe();
  }

  getCountryWiseState(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CountryStateWise/fetch', payload).pipe();
  }

  getParentId(payload): Observable<any> {
    return this.http.post(this.APIService + '/stuFormSettings/SetPanelParentList/fetch', payload).pipe();
  }

  getFeecount(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/DashboardFeeAdmDtl/fetch', payload).pipe();
  }

  addUserSubjectMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/MarkEntryMapping', payload).pipe();
  }

  getSubUsermappingList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/MarkEntryMapping', payload).pipe();
  }

  saveStdAtdSetting(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StuAttendanceSet', payload).pipe();
  }

  getStuId(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/personalDetails/fetch', payload).pipe();
  }

  SearchRejectRegn(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/rejectedstudents/fetch', payload).pipe();
  }

  addCastSessionCutOff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CastewiseIntake', payload).pipe();
  }

  updateCastSessionCutOff(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/CastewiseIntake', payload).pipe();
  }


  updatePersonalDetails(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/personalDetails', payload).pipe();
  }

  updateContactDetails(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/AddressDetails', payload).pipe();
  }

  PreviousMarks(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/PreviousMarks', payload).pipe();
  }

  UpdateIAAndPracticalMarks(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/IAAndPracticalMarks', payload).pipe();
  }

  VldtRecordRollNo(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/AssignRollNos', payload).pipe();
  }

  fetchRegNoList(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/SearchRegnForm/fetch', payload).pipe();
  }

  getStudentsHoldData(payload: any): Observable<any> {
  let params = new HttpParams().set('examId', payload.examId);
  if (payload.prnNo) {
    params = params.set('prnNo', payload.prnNo);
  }
  return this.http.get( this.APIService + '/masters/student-hold-data', { params });
 }

  updateInactive(payload:any):Observable<any>{
    return this.http.put(this.APIService  +  '/masters/update-hold-students-data',payload).pipe();
  }

  fetchTableDataList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditStatus/fetch', payload).pipe();
  }

  addStudentStatus(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditStatus', payload).pipe();
  }

  updateStudentStatus(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditStatus', payload).pipe();
  }

  SearchScrutinyReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/ScrutinyReports/fetch', payload).pipe();
  }

  getSessionIntakeCutoff(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CastewiseIntake/fetch', payload).pipe();
  }

  paymentgateway(payload): Observable<any> {
    return this.http.post(this.APIService + "/fees/payment", payload).pipe();
  }

  fetchIntakeFilterForCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CollegeWiseCourse/fetch', payload).pipe();
  }

  fetchFeeTemp(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetemp', payload).pipe();
  }

  getSchForUpdtReslist(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/getSchForUpdtReslist', payload).pipe();
  }

  DownloadSectionMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/DownloadSectionMarks/fetch', payload).pipe();
  }

  DownloadChangeMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/DownloadChangeMarks/fetch', payload).pipe();
  }

  DownloadMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/DownloadMarksByRollNo/fetch', payload).pipe();
  }

  fetchCourseType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/course/fetch', payload).pipe();
  }

  GetTclcData(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/tclcData/fetch', payload).pipe();
  }

  AddCertScr(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CertScrutiny', payload).pipe();
  }

  UpdateTclc(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/tclcmc', payload).pipe();
  }

  GetCertScr(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CertScrutiny/fetch', payload).pipe();
  }

  GetTclcStudents(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/TclcStudents/fetch', payload).pipe();
  }

  getFeeTclc(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetempTclc', payload).pipe();
  }

  offlinePayResponce(payload): Observable<any> {
    return this.http.post(this.APIService + "/fees/Offlinepayment", payload).pipe();
  }

  addComplaint(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievances', payload).pipe();
  }

  updateComplaint(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/Grievances', payload).pipe();
  }

  DistrictWiseCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/DistrictWiseCollege/fetch', payload).pipe();
  }

  getComplaint(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievances/fetch', payload).pipe();
  }

  getDepartment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Departments/fetch', payload).pipe();
  }

  addAction(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Actions', payload).pipe();
  }

  getAction(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Actions/fetch', payload).pipe();
  }
  getComment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Comments/fetch', payload).pipe();
  }
  getActionComment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetGrievance_ActionsAndComments/fetch', payload).pipe();
  }

  addComment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/Grievance_Comments', payload).pipe();
  }

  getApplyData(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/StuAdmFrmDtls/fetch', payload).pipe();
  }

  getCasteData(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CasteMaster/fetch', payload).pipe();
  }

  addCaste(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CasteMaster', payload).pipe();
  }

  updateCaste(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/CasteMaster', payload).pipe();
  }

  getCasteCategoryData(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CasteCategory/fetch', payload).pipe();
  }

  addCasteCategory(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/CasteCategory', payload).pipe();
  }

  updateCasteCategory(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/CasteCategory', payload).pipe();
  }

  SearchTranscript(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchTranscript/fecth', payload).pipe();
  }

  GetTcLcDocDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/tclcDocDetails/fetch', payload).pipe();
  }

  payZeroFee(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/paymentresponse', payload).pipe();
  }

  addGrievanceAssign(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/GrievanceAssign', payload).pipe();
  }

  getFeeResponse(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/FeeResponse', payload).pipe();
  }

  getGrievanceAssign(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/GrievanceAssign/fetch', payload).pipe();
  }

  getCenterCollegeForReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/GetCenterWiseAdmit', payload).pipe();
  }

  CommonDocument(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CommonDocumentDetails/fetch', payload).pipe();
  }

  GetTcLcDocUploadDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/tclcDocUploadDetails/fetch', payload).pipe();
  }

  saveDocUploadDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/saveTclcDocUploadDetails', payload).pipe();
  }

  updateDocUploadDetails(payload): Observable<any> {
    return this.http.put(this.APIService + '/admin/UpdateDocsUploadDetails', payload).pipe();
  }

  fetchFeeTempTclc(payload): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchFeetempTclc', payload).pipe();
  }


  AddWithHold(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditExcp', payload).pipe();
  }

  UpdtWithHold(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditExcp', payload).pipe();
  }

  VldtWithHold(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/VldtEditExcp', payload).pipe();
  }

  SearchWithHold(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/SearchEditExcp/fetch', payload).pipe();
  }

  fetchPackingList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/PackList/fetch', payload).pipe();
  }

  updatePackingList(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/PackList', payload).pipe();
  }

  fetchSubChgList(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditSubChngRg/fetch', payload).pipe();
  }

  saveSubChg(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/EditSubChng', payload).pipe();
  }

  updateSubChg(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/EditSubChng', payload).pipe();
  }

  getStuNotify(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StuNotification/fetch', payload).pipe();
  }

  AddStuNotify(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StuNotification', payload).pipe();
  }

  UpdtStuNotify(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/StuNotification', payload).pipe();
  }

  addPaymentGatewayType(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/paymentGatewayType', payload).pipe();
  }

  updatePaymentGatewayType(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/updatePaymentGatewayType', payload).pipe();
  }

  getPaymentGateway(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/paymentGatewayType/fetch', payload).pipe();
  }

  searchPaymentGateway(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/paymentGatewayType/fetch', payload).pipe();
  }

  getSlmData(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AdSlmDetails/fetch', payload).pipe();
  }

  addSlmQuantity(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/AddSlm', payload).pipe();
  }

  AddTentative(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeSchedule', payload).pipe();
  }
  getTentative(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeSchedule/fetch', payload).pipe();
  }
  AddTentativeMaster(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleMasters', payload).pipe();
  }
  getTentativeMaster(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleMasters/fetch', payload).pipe();
  }
  UpdateTentativeMaster(payload): Observable<any> {
    return this.http.put(this.APIService + '/inputs/TentativeScheduleMasters', payload).pipe();
  }
  AddTentativeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleDetails', payload).pipe();
  }
  getTentativeDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/inputs/TentativeScheduleDetails/fetch', payload).pipe();
  }
  addDepartment(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/AddDepartment', payload).pipe();
  }

  updateDepartment(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/UpdateDepartment', payload).pipe();
  }

  getDeptData(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetDepartment/fetch', payload).pipe();
  }
  addDepartmentSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/AddDepartmentSubject', payload).pipe();
  }
  getDeptSubData(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetDepartmentSubject', payload).pipe();
  }
  getCoursewiseSub(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetSubject', payload).pipe();
  }

  saveTeachersData(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/TeacherProfile', payload).pipe();
  }


  updateTeachersData(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/TeacherProfile', payload).pipe();
  }


  getTeachersData(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/getTeacherProfile/fetch', payload).pipe();
  }

  getSubTeachers(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/getInternalExternalTeacher/fetch', payload).pipe();
  }


  saveExaminer(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InternalExternalTeacher', payload).pipe();
  }
  //mapping
  getExaminer(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/fetchInternalExternalTeacher/fetch', payload).pipe();
  }

  deleteExaminer(payload): Observable<any> {
    return this.http.delete(this.APIService + '/supervisor/InternalExternalTeacher', payload).pipe();
  }

  getTeacherPerticular(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/getTeacherMappingDetails/fetch', payload).pipe();
  }

  getPracticalTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalTimeTable/fetch', payload).pipe();
  }

  savePracticalTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalTimeTable', payload).pipe();
  }

  updatePracticalTimeTable(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/PracticalTimeTable', payload).pipe();
  }


  CheckPracticalTimeTable(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetCheckPracticalTimeTable/fetch', payload).pipe();
  }

  getBlock(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetCollegeBlock/fetch', payload).pipe();
  }

  saveBlock(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/AddCollegeBlock', payload).pipe();
  }

  updateBlock(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/UpdateCollegeBlock', payload).pipe();
  }

  deleteBlock(payload): Observable<any> {
    return this.http.delete(this.APIService + '/masters/DeleteCollegeBlock', payload).pipe();
  }

  saveCapacity(payload): Observable<any> {
    return this.http.put(this.APIService + '/masters/UpdateCollegeCapacity', payload).pipe();
  }

  saveAvailablityTeacher(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InternalExternalTeacherAvailablity', payload).pipe();
  }

  getTeacherAvailablity(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InternalExternalTeacherAvailablity/fetch', payload).pipe();
  }


  updateTeacherAvailability(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/InternalExternalTeacherAvailablity', payload).pipe();
  }
  updateTeacherAssignemt(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/InternalExternalTeacherAcceptStatus', payload).pipe();
  }
  getfinalTeachers(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get-internal-external-final', payload).pipe();
  }

  getSubWiseTeachers(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/SubWiseInternalExternalTeacher/fetch', payload).pipe();
  }

  generateRandomAssiTea(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InternalExternalTeacherRandomAssignment', payload).pipe();
  }

  getProvisionalAssTeachers(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ProvisionalAssignedTeacher/fetch', payload).pipe();
  }
  getFinalAssTeachers(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/FinalAssignedTeacher/fetch', payload).pipe();
  }
  publishAssTeachers(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/UpdatePublishStatus', payload).pipe();
  }
  getPracticalDate(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalExamDate/fetch', payload).pipe();
  }
  getWaitingTeachersData(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InternalExternalReassign/fetch', payload).pipe();
  }
  ReProvisionTeachersData(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/InternalExternalReassign', payload).pipe();
  }
  collegewisestudentData(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/CollegeWiseStudent/fetch', payload).pipe();
  }
  StudentFetchForOptionalSubject(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StudentFetchForOptionalSubject/fetch', payload).pipe();
  }
  updatePhotoSignDetails(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/StudentPhotoAndSign', payload).pipe();
  }

  addPhotoSignDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StudentPhotoAndSign', payload).pipe();
  }

  getTeacherEligibilityData(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/fetchInternalExternalTeacherEligibility/fetch', payload);
  }

  // searchTeacherEligibilityData(payload): Observable<any> {
  //   return this.http.post(this.APIService + '/supervisor/fetchInternalExternalTeacherEligibility/fetch', payload);
  // }

  addNewRecord(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/InternalExternalTeacher', payload);
  }

  editTeacherEligibility(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/InternalExternalTeacher', payload);
  }

  deleteTeacherEligibility(payload: any): Observable<any> {
    return this.http.request('delete', this.APIService + '/supervisor/InternalExternalTeacher', {
      body: payload
    });
  }


  getExamFormClgwise(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/ClgWiseExamFormStudentList', payload).pipe();
  }

  addTeacherEligibility(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/TeacherEligibility', payload).pipe();
  }

  updateTeacherEligibility(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/TeacherEligibility', payload).pipe();
  }

  searchTeacherEligibility(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/TeacherEligibility/fetch', payload).pipe();
  }

  saveFilesDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/FileUpload', payload).pipe();
  }
  getFilesDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetFile', payload).pipe();
  }
  saveFilesDetailscon(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/FileUpload/Convocation', payload).pipe();
  }
  getFilesDetailscon(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetFile/Convocation', payload).pipe();
  }
  updateCon(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/ConVoc/update', payload).pipe();
  }
  updateABCId(payload): Observable<any> {
    return this.http.put(this.APIService + '/students/ABCId', payload).pipe();
  }

  // IA Marks Apis start //

  getExamSubMapUserWiseFetch(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/getIASubject/fetch', payload).pipe();
  }
  fetchCoColStrMapping(payload): Observable<any> {
    return this.http.post(this.APIService + '/admin/CoColStrMapping', payload).pipe();
  }
  getStuIAMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StudentIAMarks/fetch', payload).pipe();
  }

  getPracMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalMarksEntry/fetch', payload).pipe();
  }

  getBatchFreezeList(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/BatchFreeze/list', payload).pipe();
  }

  updateBatchAllocations(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/BatchFreeze/update', payload).pipe();
  }
  freezeBatchAllocations(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/BatchFreeze/freeze', payload).pipe();
  }

  addStuPracMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalMarksEntry/add', payload).pipe();
  }

  updateStuPracMarks(payload): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/PracticalMarksEntry/update', payload).pipe();
  }

  deleteStuPracMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalMarksEntry/delete', payload).pipe();
  }

  saveFinalPracMark(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalMarksEntry/saveFinal', payload).pipe();
  }

  getPracticalBatches(payload): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/PracticalMarksEntry/getBatches', payload).pipe();
  }

  saveStuIAMarksSet(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/StudentIAMarks', payload).pipe();
  }

  updateStuIAMarksSet(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/StudentIAMarks', payload).pipe();
  }

  getIAMarksUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/IAMarksUser/fetch', payload).pipe();
  }

  reportStuIAMarks(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/ReportStudentIAMarks/fetch', payload).pipe();
  }

  saveStuIAMarksUser(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/IAMarksUser', payload).pipe();
  }

  updateStuIAMarksUser(payload): Observable<any> {
    return this.http.put(this.APIService + '/security/IAMarksUser', payload).pipe();
  }
  getIAMarksHeadData(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/IAMarksUser/fetch', payload).pipe();
  }

  getstateCollege(payload): Observable<any> {
    return this.http.post(this.APIService + '/masters/GetStateWiseCollege', payload).pipe();
  }
  saveFinalIAmark(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/UpdateStuIAMarksFinalStatus', payload).pipe();
  }


   //new APIs for seat number with PRN
  getSeatNoWithPRN(payload): Observable<any>{
    return this.http.post(this.APIService + '/report/getStudentExamDetails/fetch', payload).pipe();
  }


  getIACountClgWise(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/CollegeWiseIAMarksCount/fetch', payload).pipe();
  }
  oldtudentData(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/OldStudent/fetch', payload).pipe();
  }
  convocationData(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/GetConvocation/fetch', payload).pipe();
  }
  fetchConvocationStudent(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/GetConvocation/fetch', payload).pipe();
  }
  generateReport(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/StudentPhotoAndSignStatus', payload).pipe();
  }

  getSubSelectionDetails(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/students/SubSelectionDetails/fetch', payload).pipe();
  }

  fetchCourseBranch(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam-stream/branch/fetch', payload).pipe();
  }
  fetchExam(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/masters/exam/fetch', payload).pipe();
  }

  insertOptionalSubjectSelectionDetails(payload): Observable<any> {
      return this.http.post(this.APIService + '/students/StudentOptionalSubjectSelection',payload).pipe();
    }

  updateOptionalSubjectSelectionDetails(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/UpdateStudentOptionalSubjectSelection', payload);
  }
  getSavedOptionalSubjects(payload): Observable<any> {
    return this.http.post(this.APIService + '/students/GetSavedOptionalSubjects',payload).pipe();
  }
  
  manageTeacherAppointments(operationType: string, payload: any): Observable<any> {
    const requestPayload = {
      OperationType: operationType,
      JsonData: JSON.stringify(payload),
      UserId: parseInt(sessionStorage.getItem('userId') || '0')
    };
    return this.http.post(this.APIService + '/supervisor/manageTeacherAppointments', requestPayload);
  }

  sendOrder(payload: any): Observable<any> {
    return this.manageTeacherAppointments('SEND_ORDER', payload);
}

    getTeacherAppointmentsForDashboard(payload: any): Observable<any> {
        return this.http.post(this.APIService + '/supervisor/getTeacherAppointmentsForDashboard', payload).pipe();
    }

    getTeacherIdByMobile(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/getTeacherIdByMobile', payload);
   }

  finalSubmitAppointment(payload: any): Observable<any> {
    return this.manageTeacherAppointments('FINAL_SUBMIT', payload);
    }

    saveTeacherAppointment(payload: any): Observable<any> {
        return this.manageTeacherAppointments('SAVE_APPOINTMENT', payload);
    }

    getTeacherAppointments(payload: any): Observable<any> {
        return this.manageTeacherAppointments('GET_APPOINTMENTS', payload);
    }

    deleteTeacherAppointment(payload: any): Observable<any> {
        return this.manageTeacherAppointments('DELETE_APPOINTMENT', payload);
    }

    getTeachersViaUnified(payload: any): Observable<any> {
        return this.manageTeacherAppointments('GET_TEACHERS', payload);
    }

    getRoles(): Observable<any> {
        return this.manageTeacherAppointments('GET_ROLES', {});
    }

    getExamScheduleById(payload: any): Observable<any> {
        return this.http.post(this.APIService + '/supervisor/getExamScheduleById', payload);
    }
    getExamTimeDateRange(payload: any): Observable<any> {
        return this.http.post(this.APIService + '/supervisor/getExamTimeDateRange', payload);
    }
    getStuElectiveMarks(payload): Observable<any> {
        return this.http.post(this.APIService + '/security/StuElectiveMarks/fetch', payload).pipe();
    }
    saveStuElectiveMarksSet(payload): Observable<any> {
        return this.http.post(this.APIService + '/security/StudentElectiveMarks', payload).pipe();
    }
    updateStuElectiveMarksSet(payload): Observable<any> {
        return this.http.put(this.APIService + '/security/StudentElectiveMarks', payload).pipe();
    }
    saveFinalElectiveMark(payload): Observable<any> {
        return this.http.post(this.APIService + '/security/FinalElectiveMarks', payload).pipe();
    }
    getCollegeCenters(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/GetCollegeCenters', payload).pipe();
    }

    updateCollegeCenters(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/UpdateCollegeCenter', payload).pipe();
    }
    generateRollNo(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/GenerateRollNo', payload).pipe();
    }
    submitFinal(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/SubmitFinalRollCent', payload).pipe();
    }
    getExcelReport(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/GenerateCenterRollReport', payload);
  }
   submitFinalAttendance(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/security/SubmitFinalAttendance', payload);
  }
 
   getPanelAssignments(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/PanelBatches', payload);
    }

    addPanelBatch(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/AddPanelBatch', payload);
    }

    updatePanelBatch(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/UpdatePanelBatch', payload);
    }

    deletePanelBatch(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/DeletePanelBatch', payload);
    }
    getExamPanelStatusFlags(payload: any): Observable<any> {
      return this.http.post<any>(this.APIService + '/supervisor/ExamPanelStatusFlags', payload);
    }
    getPanelList(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/GetPanelList', payload);
    }
    getSavedPanelForBatch(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/GetSavedPanelForBatch', payload);
    }
    savePracticalPanel(payload: any): Observable<any> {
      return this.http.post(this.APIService + '/supervisor/SavePracticalPanel', payload);
    }   
  generateReciprocalProviList(payload: any): Observable<any> {
  return this.http.post(this.APIService + '/supervisor/InsertInternalExternalTeacherRandomAssignmentReceprocal', payload);
}


  getFinalReplacementCandidates(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetFinalReplacementCandidates', payload);
  }
  replaceFinalTeacher(payload: any): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ReplaceFinalTeacher', payload);
  }
    acceptAllExaminers(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/AcceptAllTeachers', payload);
  }
  getprovisionalReplacementCandidates(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/GetProvisionalReplacementCandidates', payload);
  }
   replaceprovisionalTeacher(payload: any): Observable<any> {
    return this.http.put(this.APIService + '/supervisor/ReplaceProvisionalTeacher', payload);
  }
    sendEmail(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/notification/send-mail', payload);
  }
   getMarksEntryViewReport(payload): Observable<any> {
  return this.http.post(this.APIService +  '/inputs/MarkEntryView/fetch',payload).pipe();
 }
 SearchOrgFeeRept(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/fees/SearchOrgFeeRept', payload).pipe();
  }
  importExamsBarcode(payload): Observable<any> {
  return this.http.post(this.APIService + '/utility/ExamsBarcodeImport', payload).pipe();
  }

  importEvaluationData(payload): Observable<any> {
    return this.http.post(this.APIService + '/utility/ExamsMarksImport', payload).pipe();
  }
  processExamsFinalMarks(payload: any): Observable<any> {
   return this.http.post(this.APIService + '/supervisor/process-exams-final-marks', payload).pipe();
    }

  submitExamsFinalMarks(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/submit-exams-final-marks', payload).pipe();
    }

  getExamsFinalMarksReport(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/get-exams-final-marks-report', payload).pipe();
    }
    getAttendanceSheetReport(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/report/AllAttendanceSheetReport/fetch', payload).pipe();
    }

   getExamsBarcode(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/getbarcode/fetch', payload).pipe();
  }

  amdExamsBarcode(payload: any): Observable<any> {
    return this.http.post(this.APIService + '/supervisor/AMDExamBarcode', payload).pipe();
  }
  getStuExamAttend(payload: any) {
  return this.http.post(this.APIService + '/supervisor/GetStuExamAttend', payload).pipe();
  }
  getStuExamAttendRollNo(payload: any): Observable<any> {
  return this.http.post(this.APIService + '/supervisor/GetStuExamAttendRollNo', payload).pipe();
  }
  updateStuExamAttendStatusBulk(payload: any) {
    return this.http.post(this.APIService + '/supervisor/UpdateStuExamAttendStatusBulk', payload).pipe();
  }
  finalizeStuExamAttend(payload: any) {
    return this.http.post(this.APIService + '/supervisor/FinalizeStuExamAttend', payload).pipe();
  }
  validateExamsFinalMarks(payload: any) {
  return this.http.post(this.APIService + '/supervisor/ValidateExamsFinalMarks',payload).pipe();
 }
  getPracticalMarksExcel(payload): Observable<any> {
    return this.http.post(this.APIService + '/report/PracticalMarksReportExcel/fetch', payload).pipe();
  }
  getCourseAtdThreshold(payload): Observable<any> {
  return this.http.post(this.APIService + '/security/CourseAttendanceThreshold/fetch', payload).pipe();
  }
  saveCourseAtdThreshold(payload): Observable<any> {
  return this.http.post(this.APIService + '/security/CourseAttendanceThreshold/insert', payload).pipe();
  }

  updateCourseAtdThreshold(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/CourseAttendanceThreshold/update', payload).pipe();
  }

  deleteCourseAtdThreshold(payload): Observable<any> {
    return this.http.post(this.APIService + '/security/CourseAttendanceThreshold/delete', payload).pipe();
  }

  downloadFile(data, filename = 'data', e) {
    this.spinner.show();
    const csvData = this.ConvertToCSV(data, e);
    const blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;',
    });
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser =
      navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {
      // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
    this.spinner.hide();
  }

  ConvertToCSV(objArray, headerList) {
    const array =
      typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';

    // tslint:disable-next-line:forin
    for (const index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = i + 1 + '';
      // tslint:disable-next-line:forin
      for (const index in headerList) {
        const head = headerList[index];

        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }
}
